import React from "react";
import "./cuadernillo.css";

function Cuadernillo({
  cuadernillos,
  cuadernilloIdState,
  cuadernilloName,
  loading,
  onSelectExistingCuadernillo,
  onCuadernilloNameChange,
  onAddCuadernillo,
}) {
  return (
    <div className="icfes-card">
      <p className="icfes-card-title">Selecciona un cuadernillo existente o crea uno nuevo</p>
      {cuadernillos.length > 0 && (
        <label className="icfes-form-group">
          <span>Cuadernillo existente</span>
          <select
            value={cuadernilloIdState}
            onChange={(e) => onSelectExistingCuadernillo(e.target.value)}
            className="icfes-input"
          >
            <option value="">Selecciona un cuadernillo</option>
            {cuadernillos.map((cuadernillo) => (
              <option key={cuadernillo.id} value={cuadernillo.id}>
                {cuadernillo.nombre}
              </option>
            ))}
          </select>
        </label>
      )}

      <div className="icfes-divider">o</div>

      <label className="icfes-form-group">
        <span>Nombre del cuadernillo</span>
        <input
          type="text"
          placeholder="Nombre del cuadernillo"
          value={cuadernilloName}
          onChange={(e) => onCuadernilloNameChange(e.target.value)}
          className="icfes-input"
        />
      </label>

      <button
        type="button"
        className="icfes-button"
        disabled={loading}
        onClick={onAddCuadernillo}
      >
        {loading ? "Guardando..." : "Guardar cuadernillo"}
      </button>
    </div>
  );
}

export default Cuadernillo;
